<div class="row">
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-warning card-header-icon">
        <div class="card-icon">
          <i class="material-icons">campaign</i>
        </div>
        <p class="card-category">Active Campaigns</p>
        <h3 class="card-title">{{ metrics.activeCampaigns }}</h3>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-info card-header-icon">
        <div class="card-icon">
          <i class="material-icons">hourglass_empty</i>
        </div>
        <p class="card-category">Prospects Pending</p>
        <h3 class="card-title">{{ metrics.prospectsPending }}</h3>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-success card-header-icon">
        <div class="card-icon">
          <i class="material-icons">check_circle</i>
        </div>
        <p class="card-category">Prospects Published</p>
        <h3 class="card-title">{{ metrics.prospectsPublished }}</h3>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-success card-header-icon">
        <div class="card-icon">
          <i class="material-icons">link</i>
        </div>
        <p class="card-category">Backlinks Live</p>
        <h3 class="card-title">{{ metrics.backlinksLive }}</h3>
      </div>
    </div>
  </div>
</div>

<div class="row mt-3">
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-danger card-header-icon">
        <div class="card-icon">
          <i class="material-icons">link_off</i>
        </div>
        <p class="card-category">Backlinks Lost</p>
        <h3 class="card-title">{{ metrics.backlinksLost }}</h3>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-secondary card-header-icon">
        <div class="card-icon">
          <i class="material-icons">warning</i>
        </div>
        <p class="card-category">URLs Without Support</p>
        <h3 class="card-title">{{ metrics.urlsWithoutSupport }}</h3>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-primary card-header-icon">
        <div class="card-icon">
          <i class="material-icons">key</i>
        </div>
        <p class="card-category">Keywords with Campaigns</p>
        <h3 class="card-title">{{ metrics.keywordsWithCampaigns }}</h3>
      </div>
    </div>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-6">
    <div class="card card-stats">
      <div class="card-header card-header-default card-header-icon">
        <div class="card-icon">
          <i class="material-icons">location_city</i>
        </div>
        <p class="card-category">Cities with Active Campaigns</p>
        <h3 class="card-title">{{ metrics.citiesWithActiveCampaigns }}</h3>
      </div>
    </div>
  </div>
</div>
